// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"7a658490","14":"7aa92530","149":"9f0d6bca","247":"25e32c1f","415":"b4039046","646":"5cb49ec7","684":"03f34f06","688":"d43c307f","722":"da73abbc","728":"7a28d773","880":"4d25665e","960":"5e9d8511"}[chunkId] + ".chunk.js";
};